import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportUtils from "../common/support_utils.js";
import SoftwareUtils from "./common-utils.js";
import { CommonSoftwareModel, CommonSoftwareView, CommonSoftwareController } from "./common-software-mvc.js";

/**********************************************************************
 * Software Upgrade MVC
 *********************************************************************/

// Inherit CommonSoftwareModel
export class ArchiveDownloadModel extends CommonSoftwareModel {
    constructor(filename) {
        super(filename);
        
        this.software_type = null;
        this.software_type_labels = {
            'tar': 'Illumio Core PCE',
            'ven': 'Illumio Core VEN',
            'ui': 'UI',
            'nen': 'NEN',
            'cli': 'CLI',
            'flowlink': 'Flowlink',
        }
        this.displayVersions = null;
    }
    
    // Object.defineProperty(ArchiveDownloadModel, 'constructor', {
    //     value: ArchiveDownloadModel,
    //     enumerable: false,
    //     writable: true,
    // });
    // ArchiveDownloadModel.prototype = Object.create(CommonSoftwareModel.prototype);
}

export class ArchiveDownloadView extends CommonSoftwareView {
    constructor(model) {
        super(model);
        
        // this.upgradeFormSubmitEvent = new IllumioEvent(this);
        // this.renderArchivesEvent = new IllumioEvent(this);

        this.elements = SoftwareUtils.createChildrenCache([ 'introductory', 'resources', 'download_form', 'upgrade_path', 'error', 'eula', 'download', 'resources-mobile' ]);
        // Notes: this.elements['downloadFormElement'] will be added later.
        
        // Render the upgrade form for the first time.
        this.renderUpgradeForm();
    }
    
    // Object.defineProperty(ArchiveDownloadView, 'constructor', {
    //     value: ArchiveDownloadView,
    //     enumerable: false,
    //     writable: true,
    // });
    
    // ArchiveDownloadView.prototype = Object.create(CommonSoftwareView.prototype);
    
    /**
     * Public method
     */
    renderResult() {
        console.debug('ArchiveDownloadView: renderResult(): ');
        console.debug(this.model);
        this.elements['introductory'].classList.remove('hidden');
        this.elements['download_form'].classList.remove('hidden');

        this.populateSelectElementsOptions();

        if (this.model.software_type) {
            this.renderArchives();
        }
    }
    
    /**
     * Public method
     */
    renderArchives() {
        console.debug('ArchiveDownloadview: renderArchives() ');
        // this.renderArchivesEvent.notify();
        this.emit('renderArchives', {});
    }
    
    /**
     * A utlity function populates both softwareType and version select element.
     * This should be a one-time invoke.
     */
    populateSelectElementsOptions() {
        const software_type_options = []
        const keys = Object.keys(this.model.data.archive_releases);
        for (let i = 0; i < keys.length; i++) {
            if (Object.keys(this.model.data.archive_releases[keys[i]]).length) {
                software_type_options.push([keys[i], this.model.software_type_labels[keys[i]] || keys[i]])
            }
        }
        IllumioDomUtils.populateSelectOptions(this.elements['downloadFormElement'].software_type, software_type_options, this.model.software_type);
    }
    
    selectOnChangeHandler(event) {
        console.debug(this);
        console.debug(event.target);
        console.debug(event.target.id);
        // this.upgradeFormSubmitEvent.notify(this.elements['downloadFormElement']);
        this.emit('upgradeFormSubmit', { element: this.elements['downloadFormElement'] });
    }
    
    // TOOD: Remove if not in use.
    // upgradeFormSubmitHandler(event) {
    //     event.preventDefault();
    //     
    //     // this.upgradeFormSubmitEvent.notify(event.target);
    // }
    
    renderUpgradeForm() {
        const fieldLabels = [ 'Software Type' ];
        
        const nameSpace = SoftwareUtils.getCurrentContentId();
        
        const formElement = document.createElement('form');
        formElement.classList.add('ilo-form');
        formElement.classList.add('upgrade-form');
        
        const fieldLabelsForEachHandler = function(fieldLabel) {
            console.debug(fieldLabel);
            const id = IllumioSupportUtils.camelCaseWords(fieldLabel);
            const fieldName = fieldLabel.toLowerCase().replace(/\s+/g, '_');
            
            const labelElement = document.createElement('label');
            labelElement.htmlFor = nameSpace + id;
            labelElement.appendChild(document.createTextNode(fieldLabel + ': '));
            labelElement.appendChild(IllumioDomUtils.createSimpleTextBlock('span', '*', 'required'));
            
            const selectElement = document.createElement('select');
            selectElement.name = fieldName
            selectElement.id = labelElement.htmlFor;
            selectElement.classList.add('select');
            selectElement.required = true;
            selectElement.onchange = this.selectOnChangeHandler.bind(this);
            
            const divElement = document.createElement('div');
            // divElement.classList.add('select');
            divElement.appendChild(labelElement);
            divElement.appendChild(selectElement);
            
            formElement.appendChild(divElement);
            
            console.debug(formElement);
            console.debug(this);
        }
        fieldLabels.forEach(fieldLabelsForEachHandler.bind(this));
        
        if (this.elements['download_form'] && this.elements['download_form'].tagName==='DIV') {
            this.elements['download_form'].classList.remove('hidden');
            this.elements['download_form'].appendChild(formElement);
            this.elements['downloadFormElement'] = formElement;
        }
    }
}

export class ArchiveDownloadController extends CommonSoftwareController {
    constructor(model, view) {
        super(model, view);
        
        // this.view.upgradeFormSubmitEvent.attach(upgradeFormSubmitEventHandler.bind(this));
        // this.view.renderArchivesEvent.attach(renderArchivesEventHandler.bind(this));

        this.view.on('upgradeFormSubmit', this.upgradeFormSubmitEventHandler.bind(this));
        this.view.on('renderArchives', this.renderArchivesEventHandler.bind(this));

        this.updateFieldValuesBasedOnLocation();
    }
    
    upgradeFormSubmitEventHandler(payload) {
        console.debug(payload);
        const formElement = (payload && payload.element) ? payload.element : null;
        console.debug(formElement);
        
            this.model.software_type = formElement.software_type.value;
            console.debug('ArchiveDownloadController: upgradeFormSubmitEventHandler(): this.model.software_type: ' + this.model.software_type);
            
            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length==2) {
                hashParts.push(this.model.software_type);
            } else if (hashParts.length==3) {
                hashParts[2] = this.model.software_type;
            }
            
            if (hashParts.length==2 || hashParts.length==3) {
                location.hash = hashParts.join('/');
                console.debug('ArchiveDownloadController: upgradeFormSubmitEventHandler(): Change location.hash to ' + hashParts.join('/'));
            } else {
                console.warn('ArchiveDownloadController: upgradeFormSubmitEventHandler(): Hash parts does not meet the expected size.');
            }
    }
    
    renderArchivesEventHandler() {
        console.debug('ArchiveDownloadController: renderArchivesEventHandler()');

        this.model.data.software_components = this.model.data.archive_releases[this.model.software_type];
        this.model.displayVersions = Object.keys(this.model.data.archive_releases[this.model.software_type]);
        this.view.renderDownloads();
    }
    
    updateFieldValuesBasedOnLocation() {
        if (location.hash) {
            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length>=3) {
                this.model.software_type = hashParts[2];
            }
        }
        console.debug('ArchiveDownloadController: updateFieldValuesBasedOnLocation(): this.model.software_type: ' + this.model.software_type);
    }
}